<template>
  <el-container class="box">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <!-- <publicFoldSearch :searchList='searchList' v-on:getSearchObj='getSearchObj'  :rightEventList='rightEventList' @rightFunc='rightFunc'/> -->
      <publicExpandSearch padBottom='0px' :searchList='searchList' ref='expSearch' v-on:getSearchObj='getSearchObj'
        :rightEventList='rightEventList' @rightFunc='rightFunc'></publicExpandSearch>
    </div>
      <el-main style="padding:0" class="content">
        <div class="main-content-list">
          <el-table :data="dataList" height="100%" :header-cell-style="{
          background: '#FAFAFA',
          color: '#333333',
          fontWeight: 'bold'
        }" tooltip-effect="dark" >
            <el-table-column align="center" label="序号" width="50">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="线下科室" prop="openDepartmentName">
            </el-table-column>
            <el-table-column align="center" :show-overflow-tooltip="true" label="所属机构" prop="hospitalName">
            </el-table-column>
            <el-table-column align="center" :show-overflow-tooltip="true" label="病种" prop="diseaseName">
            </el-table-column>
            <el-table-column align="center" width="200" fixed="right" label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="editClick(scope.row)">编辑</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
      <el-footer>
        <el-pagination background :current-page="searchParams.current" :page-sizes="[10, 20, 30, 50]"
          :page-size="searchParams.size" layout="total, sizes, prev, pager, next, jumper" :total="total"
          @size-change="handleSizeChange" @current-change="handleCurrentChange" />
      </el-footer>
  </el-container>
</template>

<script>
import { pageForDepartment } from "./api";
export default {
  components: {},
  props: {},
  data() {
    return {
      breadList: [{ name: "机构组织" }, { name: "资料配置" }],
      searchList: [
        {
          label: "机构名称",
          paramName: "hospitalName",
          inputType: "input",
          maxNum: 20
        },
        {
          label: "科室名称",
          paramName: "openDepartmentName",
          inputType: "input",
          maxNum: 20
        }
      ],
      rightEventList: [{ eventName: "新增", eventValue: 1 }],
      searchParams: {
        current: 1,
        size: 10
      },
      searchEnd: {}, //保留从其他页面返回时已存在的搜索条件
      total: 0,
      dataList: []
    };
  },
  watch: {},
  computed: {},
  created() {
    if (this.$store.state.userPlatForm === "platForm") {
      // 平台--线下机构接口列表
      // this.pageForDepartmentRequest();
    } else {
    }
    this.pageForDepartmentRequest();
  },
  mounted() {},
  methods: {
    /**
     * @description: 线下机构列表
     */
    pageForDepartmentRequest() {
      pageForDepartment(this.searchParams).then(res => {
        if (res.code == 0) {
          if(res.data && res.data.records.length > 0){
            this.dataList = res.data.records;
          }else{
            this.dataList = res.data.records;
          }
          this.total = res.data.total
        }
      });
    },
    handleSizeChange(val) {
      this.searchParams.size = val;
      this.searchParams.current = 1
      this.pageForDepartmentRequest()
    },
    handleCurrentChange(val) {
      this.searchParams.current = val;
      this.pageForDepartmentRequest()
    },
    editClick(item) {
      //编辑
      this.$router.push({
        path: "/Organization/dataConfigurationAddEdit",
        query:{
          id:item.id
        }
      });
    },
    rightFunc(item) {
      if (item.eventValue == 1) {
        this.$router.push({
          path: "/Organization/dataConfigurationAddEdit"
        });
      }
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.pageForDepartmentRequest();
    }
  }
};
</script>
<style lang="less" scoped>
.box {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-content-list {
  margin: 15px;
  background: #fff;
}
/deep/.el-pagination {
  float: right;
  margin-top: 20px;
}
/deep/.el-table__body-wrapper{
  height:auto !important;
}
</style>